import React, { useState, useEffect } from 'react'
import { getOtp, companyData } from "../../../services/area";
import { getCityList } from "../../../services/area";
import { Paper } from "../../../Components/Paper/Paper";
import LicenceIcon from "../../generics/Licenceicon";
import PanIcon from "../../generics/PanIcon";
import ImageInput from "../../../Components/ImageInput";
import CompanyIcon from "../../generics/CompanyIcon";
import "../css/partners.css"
import { toast } from 'react-toastify';
import { TextField, useMediaQuery, useTheme } from '@mui/material';
import { showHttpError } from './../../../utils/message';
import jsonToFormdata from "../../../utils/jsonToFormdata";
import { useCallback } from 'react';
import AutoComplete from "../../../Components/AutoComplete";
import ContactDetailsForm from './FormikForms/contactDetailsForm';

const PartnersForms = (props: any) => {
    console.log("6000", props)
    const [formNo, setFormNo] = useState(0);
    const [sourceCity, setSourceCity] = useState("");
    const [cities, setCities] = useState([]);
    const [companyTypeList, setCompanyTypeList] = useState([]);
    const [vehicleTypeList, setVehicleTypeList] = useState([]);
    const [vehicleType, setVehicleType] = useState("");
    const [vehicleModelTypeList, setVehicleModelTypeList] = useState([]);
    const [vehicleModel, setVehicleModel] = useState("");
    const [formType, setFormType] = useState("");
    const [token, setToken] = useState("");

    const theme = useTheme();
    const isMobile1 = useMediaQuery(theme.breakpoints.down('sm')); // Change the breakpoint as needed
    const isMobile2 = useMediaQuery(theme.breakpoints.down('xs')); // Change the breakpoint as needed
    const mobileView = isMobile1 || isMobile2

    const onVerify = useCallback((token:any) => {
        setToken(token);
    }, []);

    useEffect(() => {
        onVerify(token);
    }, [onVerify]);

    const Step5 = (props: any) => {
        return (
            <React.Fragment>
                <Paper elevation={4} style={{ padding: "36px", borderRadius: "6px", border: "0.2px solid transparent", display: "block", boxShadow: "none" }}>
                    <div className='uploadDoc'>
                        <span>Pancard:</span>
                        <ImageInput
                            name="pancard"
                            Icon={PanIcon}
                            value={data.pancard}
                            onChange={(e: any) => props.handlePanCardChange("pancard", e)}
                        />
                    </div>
                    <br />
                    {formType === "TransportCompnay" ?
                        <></> :
                        <div className='uploadDoc'>
                            <span>License:</span>
                            <ImageInput
                                name="License"
                                Icon={LicenceIcon}
                                value={data.licence}
                                onChange={(e: any) => props.handleLicenceUserChange("licence", e)}
                            />
                        </div>
                    }
                    {formType === "TransportCompnay" ?
                        <></> : <br />}
                    <div className='uploadDoc'>
                        <span>{formType === "TransportCompnay" ? "Company Logo:" : "User Profile:"}</span>
                        <ImageInput
                            name="User Profile"
                            Icon={CompanyIcon}
                            value={data.userProfile}
                            onChange={(e) => props.handleUserProfileChange("userProfile", e)}
                        />
                    </div>
                    <br />
                    <div>
                        <TextField
                            rows={0}
                            multiline={true}
                            label="Pancard Number"
                            placeholder="Enter Pancard Number"
                            variant="outlined"
                            type="text"
                            className="partnerFormInput"
                            value={data.panNumber}
                            onChange={(e: any) => {
                                // handleChange(["panNumber"], e.target.value)
                                setdata({ ...data, ["panNumber"]: e.target.value })
                            }}
                        ></TextField>
                    </div>

                    {formType === "TransportCompnay" ? <></>
                        : <div className='tac'>
                            <label>Select License Expiry date</label>
                            <TextField
                                rows={0}
                                multiline={true}
                                label="Select Date"
                                variant="outlined"
                                type="date"
                                className="partnerFormInput licenseDate"
                                value={data.date}
                                onChange={(e: any) => {
                                    handleChange(["date"], e.target.value)
                                }}
                            ></TextField>
                        </div>
                    }
                </Paper>
            </React.Fragment>
        );
    };

    const [data, setdata] = useState<any>({
        companyName: "",
        kind: "",
        companyEmail: "",
        website: "",
        fName: "",
        lName: "",
        email: "",
        contactNo: "",
        password: "",
        line1: "",
        line2: "",
        pincode: "",
        city: "",
        branchName: "",
        shortName: "",
        AccountNo: "",
        AccountHolder: "",
        IFSCcode: "",
        pancard: null,
        panNumber: "",
        licence: null,
        userProfile: null,
    });

    useEffect(() => {
        console.log(data, "with 200")
    }, [formNo])

    const setUpData = async () => {
        try {
            const [cityList] = await Promise.all([
                getCityList(),
            ]);
            setCities(cityList);
        } catch (err : any) { }
    };

    const handelgetOtp = () => {
        getOtp(data.contactNo);
    };

    useEffect(() => {
        setUpData();
        defineVehicleType();
        defineVehicleModelType();
        defineCompanyType();
        { props.formName === "TransportCompnay" ? setFormType("TransportCompnay") : "" }
    }, []);

    const handleChange = (name: any, event: any) => {
        setdata({ ...data, [name]: event });
    };

    const handlePanCardChange = (name: any, event: any) => {
        setdata({ ...data, [name]: event });
    };

    const handleLicenceUserChange = (name: any, event: any) => {
        setdata({ ...data, [name]: event });
    };

    const handleUserProfileChange = (name: any, event: any) => {
        setdata({ ...data, [name]: event });
    };

    const defineVehicleType = () => {
        const VehicleTypesArr: any = [{ id: 1, name: "ACE/DOST/PICKUP" }, { id: 2, name: "EICHER" }, { id: 3, name: "TRUCK" }, { id: 4, name: "CONTAINER" }, { id: 5, name: "TRAILER" }]
        setVehicleTypeList(VehicleTypesArr)
    }

    const defineCompanyType = () => {
        const CompanyTypesArr: any = [{ id: 1, name: "LLC" }, { id: 2, name: "Pvt Ltd" }, { id: 3, name: "Sole Partnership" }, { id: 4, name: "LLP" }, { id: 5, name: "Public Ltd" }]
        setCompanyTypeList(CompanyTypesArr)
    }

    const defineVehicleModelType = () => {
        const VehicleModelTypesArr: any = [{ id: 1, name: "Half Covered" }, { id: 2, name: "Full Covered" }, { id: 3, name: "Flat Bed (Open From All Sides)" }]
        setVehicleModelTypeList(VehicleModelTypesArr)
    }

    const handleBtns = (typo: any) => {
        if (typo === "Next") {
            if (formNo === 0) {
                if (data.fName === "" || data.lName === "" || data.email === "" || data.password === "" || data.contactNo === "" || data.otp === "") {
                    toast.error("All Field are Required !");
                }
                else {
                    toast.success("Page 1 Details Fullfield");
                    setFormNo(formNo + 1);
                }
            }
            if (formNo === 1) {
                if (data.companyName === "" || data.kind === "" || data.companyEmail === "" || data.website === "") {
                    toast.error("All Field are Required !");
                }
                else {
                    toast.success("Page 2 Details Fullfield");
                    setFormNo(formNo + 1);
                }
            }
            if (formNo === 2) {
                if (data.branchName === "" || data.shortName === "" || data.line1 === "" || data.line2 === "" || data.pincode === "" || data.city === "") {
                    toast.error("All Field are Required !");
                }
                else {
                    toast.success("Page 3 Details Fullfield");
                    setFormNo(formNo + 1);
                }
            }
            if (formNo === 3) {
                if (data.AccountHolder === "" || data.AccountNo === "" || data.IFSCcode === "") {
                    toast.error("All Field are Required !");
                }
                else {
                    toast.success("Page 4 Details Fullfield");
                }
            }
        }
        if (typo === "Previous") {
            setFormNo(formNo - 1);
        }
        if (typo === "Signup") {
            toast.success("company create successfully");
            console.log(data);
        }
    }

    const handleSubmit = async () => {
        try {
            if (data.panNumber) {
                let payload = {
                    contactPerson: {
                        contact: data.contactNo,
                        name: {
                            fName: data.fName,
                            lName: data.lName,
                        },
                        password: data.password,
                        email: data.email,
                    },
                    address: {
                        l1: data.line1,
                        l2: data.line2,
                        pincode: data.pincode,
                        city: data.city,
                    },
                    otp: data.otp,
                    recaptcha: "ABCD",
                    panNumber: data.panNumber,
                    bankAccount: data.AccountNo,
                    ifscCode: data.IFSCcode,
                    companyName: data.companyName,
                    kind: data.kind,
                    email: data.companyEmail,
                    branchName: data.branchName,
                    shortName: data.shortName,
                    //   regNumber: data.fleetNo,
                    //   fleetType: data.fleetType,
                    //   bodyType: data.bodyType,
                    //   active: true,
                    //   isDocVerified: true,
                    //   twoFactorAuthentication: true,
                    panCardImage: data.pancard,
                    companyLogo: data.userProfile,
                    displayName: data.displayName,
                };
                await companyData(jsonToFormdata(payload));
                toast.success("company create successfully");
                setdata({
                    companyName: "",
                    kind: "",
                    companyEmail: "",
                    website: "",
                    fName: "",
                    lName: "",
                    email: "",
                    contactNo: "",
                    password: "",
                    line1: "",
                    line2: "",
                    pincode: "",
                    city: "",
                    branchName: "",
                    shortName: "",
                    AccountNo: "",
                    AccountHolder: "",
                    IFSCcode: "",
                    pancard: null,
                    panNumber: "",
                    licence: null,
                    userProfile: null,
                });
                setFormNo(0);
                clearAllData();
            } else {
                toast.error("pancard Required");
                showHttpError("pancard Required");
            }
        } catch (err : any) {
            toast.error(err.message);
            showHttpError(err.message);
        }
    };

    const clearAllData = () => {
        setdata({
            companyName: "",
            kind: "",
            companyEmail: "",
            website: "",
            fName: "",
            lName: "",
            email: "",
            contactNo: "",
            password: "",
            line1: "",
            line2: "",
            pincode: "",
            city: "",
            branchName: "",
            shortName: "",
            AccountNo: "",
            AccountHolder: "",
            IFSCcode: "",
            pancard: null,
            panNumber: "",
            licence: null,
            userProfile: null,
        });
    }

    return (
        <>
            {mobileView ?
                <>
                    <div className='partNersFormDiv'>
                        <div style={{ border: "0.2px solid transparent", marginTop: "15%" }}>
                            <div className="url-title-div">
                                <h2 className="url-title" style={{ width: "100%" }}>{props.formName === "TransportCompnay" ? "Transport Company" :
                                    props.formName === "individualWithFleet" ? "Individual With Fleet" : "Direct Sales Agent"}</h2>
                            </div>
                        </div>
                        <div className='parnersImageConainer'>
                            <img src='data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxMQEhIQEBIQEhUWGBUWFRAWFRUVFhYVFRcWGBUTExMYHiggGBolHhYVIT0iJSorLi4uFx8zODY4NygtLisBCgoKDg0OGxAQGyslICYwLi0tLSstLS0tLS0tMS0tLy0vLS0tLS4tLS0tLS0rNS0tLTUtLS0tLS0tLy0tLS0tLf/AABEIAOEA4QMBIgACEQEDEQH/xAAcAAEAAQUBAQAAAAAAAAAAAAAABgECAwQHBQj/xABAEAACAQIDBAYHBQYGAwAAAAAAAQIDEQQSIQUxQVEGE2FxgZEHIjJSobHBFEKSstEjJGJygsIzNHOjs/Alg6L/xAAaAQEAAgMBAAAAAAAAAAAAAAAABAUBAgMG/8QAMxEAAgECAwQIBAcBAAAAAAAAAAECAxEEEjEhQWGxBRNRcYGRocEiMtHwFCQzNGJy4UL/2gAMAwEAAhEDEQA/AO4gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoVAAAAAAAAAAAAAABQAqChUAAAAAAAAAAAoVAABQAqAAAAAAAAAAAAAAAAAAAAAAAACydRRTbaSW9vRLvZg+1rgqj7VTm14O2plRb0RhtI2SppwxtNyyZrSe6Mk4SfPKpJN+BuBprUJp6AAGDIMOJrZIuVr2t5NpMpiM6s4Wdt8XpddkuDNXG4un1bVRyjnTWWzz8n6v13G0Y3a3mspWTPRLIzTvZp20fY+Ro0dpQq3hTladtFJNPvS4m3QoqEVFcOPFvi32sSi4/NqZUk9DMADUyAAAAAAAAAAAAAAAAAAAeTi9otzdGglOp96T9imuc3xfYVhsqy/xsRn3ymp73/I7xS7LHXq7K83a/wB34L17EzTPd/Cr/eneeqRzaFaripunhpOEIXz11KUU5e5G2/8A747lXZ9aSyPEtwekvUip5eKU1przsejh6MacVCCUYrRJG0ZRp/Emm92tlx2pXfA1knPY9i9X3WZWjTyxUVd2SV27t24t8WZTFWqxhGU5yjGMU3KUmkklq229EiK4n0j7PhXo4eNZVnVaSq0bVacZSkowjKUW9W3wvbjY4HTYiRRjnqSb1VNpKP8AG0pOXlKKXLUy1MTCObNKKyrNK7Syxd7SlyWj17GYpt05OaTcZWzJK7UlpmtvellZa+qtN5ZUpUazU5KnJ03ve+L0dpLhqk7Pik96NrJ66cDW7WmpWUIYml60ZZZarMnGWj9WcU9Yvino9w2VVcoWm7yg3CUubVtfJopidpQjpBqpN6RjHXXta3c+ZHcVt94ddVSUZTT9eo9Vm3WSW+ySV+LR3pUJ1FlS4rh2/Ticp1YweZvv+n3oTIEJwvS2qn+0jCceNlll4a2JfhMTGrCNSDvGSun+prXw9Sj8y2dpvTrQqfKZyN18O6lSrJ39prwjol/3mSCrPLFyteybt3EYwGKqubhlzublK60jzevC36G2Hv8AE1qYrW2JmDE03B3T1XrRlya3Mk8qDlq51FdL1U1FLxSv8TTp7KcpqdWSdtckd3Zdveuw3IRnGW/NBt7/AGo9z4r4ozWqqVrPajWnBq91qbFONklrpzbb8W95eARSQACjAKgAAAAAAAAGGDk1e68jMYaK9XzAK2lzXkVtLmvIrTjYvANWhhurTUFCKbbaStdvezNaXNeRkAvfUJWMdpc15C0ua8izGO1Oo/4ZfJkOWJn79T8Uv1JFCh1qbucqlXJuMvpP2XisVgXQwzp3lOHWKTcbwjeWWL3Xcow36WueTsPo5h6EaNSGHpKpkg88oPP1mjby1Mzjx0vdfFSOl0twTnSwn2inUrTUY9XG87Sy7pyV1F97vczwUaeepXahCms0pPRRtxk+XG5EnmvYmUOrtKT++49qhJtXfM0ZbPlNydWaaeW0YxtbK24XbbzWbzblr2aHnbQx8Z0KdShVjKMpO06c000lr60WeHjcVUyP9pU4felz7yfQw0prMna/Ar61WMdjV7EsjQnRjWleEtJSTUcsr2btJ3d0c7MzxlR6OpN9meX6mEt8Lh3RzXd723W0K+vWVS1la1/UE16EyfUzT3Kbt4xick2x0gr4ecrYe9KLy55Kazdqnu+Z6/R/pIsTF9VKpTktZU8zTXare0u05Vp08SnSjLbfkb01Oi1NrZbnv7uJ2SpTUk4yV0001zT3oxYbCwpq0IpaJX3uy3Xb1ZFOhtecq01Kc5LI9HJv70eZMynr0XSnlbuWVKp1kc1rAAHE6AAAAAAAAAAAAAAAAxYfd4symLDvTxYBfJ21LeuQrP1WaSS7PMA3o1Ezzdq7WVJ5IpSn27l39puYfs/Uie02+uqX95+XD4WJOFpRqS+Lcca83GOwz1Nr1pJpyVmmmsq3PeRbpmpPBYjI3FqF9PdTTkvFJnstmvtGh1lKrTf3oTj5xaLLq4qLUVa5Dcne7Zw3CV3TkpR4eHk+DOzY/bn2rC1Zxm3nwVKTafGNT9pF/iaa7zh7k1rw+R6mzdqVqMJ9U/UmpRleN161syvw4FdSlFKWZap+exkiV9lu378SZ+jduNbF01pC1OeS90pNyWZLg2reS5E7qQUlZ7jkHRfaWLhVqvCU41ZzUc8XFySim7PSStvtqdf2fTnKhTqVcsamSLqQW6M7etFavc78STRrxhBKWzjtt5mjozqSeVX4f5vMEsFF7ro0atNxdmeuRzpbt6lhMub1qjTaprfbg5P7q3lgquT53s4kOVPMvhNmjUp1MyTjKztON90rWtKPHxI1sbDU3jKlbDQcKSg4SdmoSqOS/wANe7aK3aeesw6O0qVWjRrV61GnKUM9WGbWnZOpkTf3lT1fJqWnAguz+msZVHGtFRpuUslRXWWLbydZF9lrteRSYSlThi51HJpXurq177fS6s+RdY3ESqYSnTSV7bbbbWslu1aW1bicYDHzoSc6TSbVm7J6XT49yPYwPSurGS65RnHi0rSXaraPuI8nyBf1MPTqfPFe/mUUK04fKzqdGqpxUou6aTT5pmU8Xok39mhfnO3dmf1ue0ebqQyTlHsbXkXMJZoqXaAAaG4AAAAAAAAAAAAMFP2fEzmvSqWVrPyAKteqzCZpVU9GpFuaPuyAFB6s87a+ynVlnh7XFPc/HmeiqkV92Rf9oXKXkbwnKDvE1lFSVmROpsytFNum7K7bvHcvE0nKyu9y1fgTPF1b05q0vZlw7Gc86SVnSwmInrpTnbvasvi0WeHrucW5biFVpqDSRxJq92k7O9u4ujUai4K6TfrLg7btPMup4ucUoxk0lwFOF4zlyy/F2IEU3p2P0V3yO0mt/wB7be56PQ/aLw2OoyldRqfs5XvrGo8qfcppa9jOy4lLLJNuN1bMt6vua7TnGzOjstpYGm1JRrUq04qpK9sksjalZX0upLtXadHx+HlCmlJ53aN5JWu1a7y62JmGt+nPSXqt68DnUzJdZH/n0e7ic4e38XsxzoVGsRBp9TVnm38JKW9rnB+DtvjG06FdtV8QpZqzbTl7UrWu8vBaq36HWXSb3xb8PiQ70hwaeGbTWs9/9B1r4TLBvNdbLLvaWu84U695WsaWI27P7F9lTdlZNWjZxWa1nbS1oLnvI9gMFOvN06avLLKVueW2i7dTNiH6r/7xN/ojioUJ1a9TdCm7Li5SlG0V2uxjFQj18YaLV+OvIUZy6ty36HudANpzqyWClrLXqrtJ+qm5U9eKSbXc1wOk7P6MVqj/AGiVOPF3Tl4JfUgXow2LPHY/7fWWSFNurFJWU6iaiop+7G92+LXed1pcSP8AjatOKgvBtbbbiRHDU5vM/wDC3D0I04xhBWjFJJdiMwBAJgAAAAAAAAAAAAAAALKkrJsvLKu59zALaFTMtTKa+F4+BsAAAtbtv0ALiMekajGps7Ewk5JSUFeNr36yFlrwuSN1o+9HzRFvSNVTwMkne86a+N/oSMJTVSvCL0bXM44mbhRnJbk+RwyewFwqNd8U/qjYwuyYRp1IOTbl961rZdVZd56BbSd1ftfzPXx6Ow0ZXUO1b9+ztPLPG13Gzl2bl39h0j0Q7KeHoVLzz9ZJTvly2bSjl3u/sX8ToKViPdBIJYKjZb02+15mvoSI8firKtJRVknby2HqcPfqot6tX8yhyH091vWwFPn18vLql9Tr5xz04V74jDU/dpyl+OVv7DOFp9ZVUfHyGInlptnL69OybvJ97JX0NxOBl1ODq0ak5YiShWlwvr1bzJ3Svltbddu/ONmTDV3SnCpHfCUZrvi018i0xOAVeSea3Dte7f2kDDYyVFNJJ339l+w+mMDQjTpwp04xhCMVGMIqyilokkblLiY6dNNJxem9dz1LlNRvd2KMtTMDGq0fej5oujJPc0wC4w16jjaxmNbFvd4gGaDuky8shuXci8AAAAAAAAAAGHFey/D5ozGHEey+9fNAFmE4+BsljmlxQ6xc0AW1Z5VcxyqJ71fsZTFzTSSfEzxs91gDX9X3V5Ii3pJa+xpJWvUh+WZMsq5EP9KL/c4/6sfy1Cb0d+6p95Fxv7efc+RzHBUesqU4e81H8TS+pftWj1davBKyjUqpLsU5JHo9CqHWY7DrlLN+GLl/ainTOlkx2IX8eb8SUvqet6z8zk/hf1t7Hmcn5bN/K3o37nTuhC/csP3S/PI94j3QKV8BQ/rX/wByJEeNxa/MVP7S5s9Vh3ejB8FyKHCvS9XzbQcb3yUqUfzT/vO7HHfSB0Vq1MbWrwqQbqKElF3WVKCglfW/sfE2wdanSqZ6jsrb+3YK9CpWjkpq7OctWWu8xy3Eoj0Exsqcq0YKUFe8lOH3d7s2mYcH0MxNWUYWhByainKatd6a5bsuPxuGVm6kfNFd+BxLulTls12aHetn1EqVOyt6kPyozSmnvVzLRpKMYx5JLyVi/KuR50tzVeX3V5IzULNXWnYXytxsYMLNKNm+IBtGrit6M/WLmgpJ8gCzDexHuMxiw3sx7jKAAAAAAAAAAULKkcyauZAAasqUn7vxMVdSgrvK/M3zV2j7K7/owDG4axTtryNqnBIxLWceyJsgFDnfpV2h/g4Vf6kvjGC/P8DopxTpxiesxuId7qMsq7MqUWvNMtuhqSnicz/5V/b3K3pWo4Yey3tL39j2fRZhc1erV4U4W/qm9PhGR5fpAf8A5DEf+v8A4qZL/RzhnTwrqLR1JSd7fdhaK+OYhvTq/wBur349W/8AbiWuHq9Z0lV4Rt5ON/W5XYink6Pp8XfzUvY6H6PJfuNLvn+eX6ElIv6OX+5Uv6v+SZKTzuM/c1P7S5su8J+3p/1jyRQhPSl/vD/lj8ibkJ6U/wCYfdH5FXjP0/EuOjP1vD3RJtm4ZRoQp8HDX+rV/NkOwMMmIgpfdqRT8JWJxgf8Omv4IfJEN6Q0smIqdtpLxWvxuaYqNoRa3ffsdcDLNUnF77vn9WTsGtg6meEJ+9GL8WtTZJ177Sqas7Mx1KaZqKHt2tpz5am+actJVF/C/kAW0YykrrL8TJGlJcY/ErgPY8WbIBZTjZJci5lQAAAAUBUAAAAAAoAGzUxMs6tBN67+HmZq1PNbW1nfvMoBqUZrO76aJWej4G4a8qF82u/jyM0VZJb+0AuOA7RrdZWqz35pyl35pN/U71Vdk2uCZxzozsCtPFUVOlVjBSUpSlFqyhrZtrS9reJe9C1IUlVnJ6W8bZn7FR0rTnV6uEU9Xu00XhvOo7OwfU0KFLjCCT/mssz87nNvSLSti2/ehGXzj/adZrU3K2qRzv0k4CXWUZwi5twlHRN+zK+tv5iP0TV/N3k9U/r7HbpKnfDZYrRq3LkSL0fxthKHbGb/ANyRKDwuiWHccJh8ycWoaxaaerb1T3bz3SDipZq83/KXNkvDxy0YLsS5AhXSSObEuK45F5pE1IrjKWbHx7HB/hjm+hX4pXglxRadHyy1JS7It+ViUQjZJciL9MaGtOpzTi/B3XzZKjxelNHNQb92Sl9H8zfExzU35nLBTyVo+XnsNrYU74el/LbybX0PQPL6O/5en/V+ZnqG9L5I9xzrq1WXe+YNOtL1nbW8WtNdTZnG6a3dpjjQtls93xNzkYsPPIssrx7Xu8zcKMsoU8qte4BkAAAAAAAAAAAAKFTG6YBdddgzos6rtKdU+wAv6xDrEWdWynVsAwbVrTjRrSoxcqqpzdOOms1F5Frpq7bzkezNodIaE1OphqtaP3oONGLfHScNU/BnY8jGV8jK2O5h3atdruNTY+0JV6UalShWw8ne9GplzK3H1W9H4PsIx6R8btCH2eOzaDq36x1Hkz5bZMi3pK95eRMsr5DK+RiyeplNrR2Of9HukO2o5YYrZbqrRdbGrRpOK3XdNt380dD6wsyvkUyvkZbMJWPP27teeHgpUsLiMVJtrJS6v1dN83OSsu65Dujm1No1toRli9nyoUpKadTV5LQeW8r21tb+o6DkfIrlfI1aT1RsnJaO27wL+sIV046U1qWbDYXA4rEzatKfU1OpSkla1SK9Z68ORMsj5DIzPeY27iLejraOJq4aaxmGlh5QqOMIuM45oNKWa0+1yXgiW9ajHkY6tmEklZGW23dvaZOsQ6xFnVsdU+wyYMmdcxftRZ1QVLtAMoLYwsXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH//2Q==' />
                        </div>
                        <div>
                            {props.formName === "TransportCompnay" ?
                                <div className='directSalesAgentContainer'>
                                    {formNo === 0 ?
                                        <div className='formPage1Container'>
                                            <div className='formPage1Heading'>
                                                <div className='formTitleName'> Contact Person  </div>  <div> Step {" "} {formNo + 1}/5 </div>
                                            </div>
                                            <div className='formPage1'>
                                                <input className='form-control' type={"text"} placeholder='First Name' />
                                                <br />
                                                <input className='form-control' type={"text"} placeholder='Last Name' />
                                                <br />
                                                <input className='form-control' type={"email"} placeholder='E-mail' />
                                                <br />
                                                <input className='form-control' type={"password"} placeholder='Password' />
                                                <br />
                                                <input className='form-control' type={"number"} placeholder='Contact No' onChange={(e: any) => { data.contactNo(e) }} />
                                                <br />
                                                <button className='btn btn-primary otpButton' onClick={() => { handelgetOtp() }}>Get Otp</button>
                                                <br />
                                                <input className='form-control otpInput' type={"number"} placeholder='Enter Otp' />
                                            </div>
                                        </div>
                                        : formNo === 1 ?
                                            <div className='formPage1Container'>
                                                <div className='formPage1Heading'>
                                                    <div className='formTitleName'> Address  </div> <div> Step {" "} {formNo + 1}/5 </div>
                                                </div>
                                                <div className='formPage1'>
                                                    <input className='form-control' type={"text"} placeholder='Branch Name' />
                                                    <br />
                                                    <input className='form-control' type={"text"} placeholder='Short Name' />
                                                    <br />
                                                    <input className='form-control' type={"text"} placeholder='Address Line 1' />
                                                    <br />
                                                    <input className='form-control' type={"text"} placeholder='Address Line 2' />
                                                    <br />
                                                    <input className='form-control' type={"number"} placeholder='Pincode' />
                                                    <br />
                                                    <select
                                                        id="inputState"
                                                        className="div-control citySelect"
                                                        value={sourceCity}
                                                        onChange={(e) => {
                                                            setSourceCity(e.target.value);
                                                        }}
                                                    >
                                                        <option label="City" value="" />
                                                        {cities.map((c: any) => (
                                                            <option
                                                                key={c._id}
                                                                label={c.name}
                                                                value={c._id}
                                                            />
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            : formNo === 2 ?
                                                <div className='formPage1Container'>
                                                    <div className='formPage1Heading'>
                                                        <div className='formTitleName'>  Attachments  </div> <div> Step {" "} {formNo + 1}/5 </div>
                                                    </div>
                                                    <div>
                                                        <Step5
                                                            handleChange={handleChange}
                                                            handlePanCardChange={handlePanCardChange}
                                                            handleLicenceUserChange={handleLicenceUserChange}
                                                            handleUserProfileChange={handleUserProfileChange}
                                                            panNumber={data.panNumber}
                                                            licenceExpire={data.licenceExpire}
                                                            pancard={data.pancard}
                                                            licence={data.licence}
                                                            userProfile={data.userProfile}
                                                        />
                                                    </div>
                                                </div>
                                                : formNo === 3 ?
                                                    <div className='formPage1Container'>
                                                        <div className='formPage1Heading'>
                                                            <div className='formTitleName'>  Company Details  </div> <div> Step {" "} {formNo + 1}/5 </div>
                                                        </div>
                                                        <div className='formPage1'>
                                                            <input className='form-control' type={"text"} placeholder='Company Name' />
                                                            <br />
                                                            <select
                                                                id="inputState"
                                                                className="fleetRegister mtop2"
                                                                value={data.kind}
                                                                onChange={(e) => {
                                                                    handleChange(["kind"], e.target.value)
                                                                }}
                                                            >
                                                                <option label="Company type" value="" />
                                                                {companyTypeList.map((c: any) => (
                                                                    <option
                                                                        key={c.id}
                                                                        label={c.name}
                                                                        value={c.name}
                                                                    />
                                                                ))}
                                                            </select>
                                                            <br />
                                                            <input className='form-control' type={"email"} placeholder='Company Email' style={{ marginTop: "-5%", marginBottom: "5%" }} />
                                                            <br />
                                                            <input className='form-control' type={"web"} placeholder='Company Website' />
                                                        </div>
                                                    </div>
                                                    : formNo === 4 ?
                                                        <div className='formPage1Container'>
                                                            <div className='formPage1Heading'>
                                                                <div className='formTitleName'>  Bank Details  </div> <div> Step {" "} {formNo + 1}/5 </div>
                                                            </div>
                                                            <div className='formPage1'>
                                                                <input className='form-control' type={"text"} placeholder='Account Holder Name' />
                                                                <br />
                                                                <input className='form-control' type={"number"} placeholder='Account Number' />
                                                                <br />
                                                                <input className='form-control' type={"text"} placeholder='IFSC Code' />
                                                            </div>
                                                        </div>
                                                        : null}
                                    <div className='changeFormbtns'>
                                        {formNo > 0 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => setFormNo(formNo - 1)}>PREVIOUS</div > : null}
                                        {formNo <= 3 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => setFormNo(formNo + 1)}>NEXT</div > : null}
                                        {formNo === 4 ? <div className="btn btn-primary-one text-white puBtn" >SignUp</div >
                                            : props.fleet && formNo === 4 ? <div className="btn btn-primary-one text-white puBtn" >SignUp</div > : null}
                                    </div>
                                </div>
                                :
                                props.formName === "individualWithFleet" ?
                                    <div className='directSalesAgentContainer'>
                                        {formNo === 0 ?
                                            <div className='formPage1Container'>
                                                <div className='formPage1Heading'>
                                                    <div className='formTitleName'> Contact Person  </div>  <div> Step {" "} {formNo + 1}/4 </div>
                                                </div>
                                                <div className='formPage1'>
                                                    <TextField
                                                        rows={0}
                                                        multiline={true}
                                                        label="First Name"
                                                        value={data.fName}
                                                        placeholder="Enter First Name"
                                                        variant="outlined"
                                                        type="text"
                                                        className="partnerFormInput"
                                                        onChange={(e: any) => {
                                                            handleChange(["fName"], e.target.value)
                                                        }}
                                                    ></TextField>
                                                    <TextField
                                                        rows={0}
                                                        multiline={true}
                                                        label="Last Name"
                                                        placeholder="Enter Last Name"
                                                        variant="outlined"
                                                        type="text"
                                                        value={data.lName}
                                                        className="partnerFormInput"
                                                        onChange={(e: any) => {
                                                            handleChange(["lName"], e.target.value)
                                                        }}
                                                    ></TextField>
                                                    <TextField
                                                        rows={0}
                                                        multiline={true}
                                                        label="Email Address"
                                                        placeholder="Enter Email Address"
                                                        variant="outlined"
                                                        value={data.email}
                                                        type="email"
                                                        className="partnerFormInput"
                                                        onChange={(e: any) => {
                                                            handleChange(["email"], e.target.value)
                                                        }}
                                                    ></TextField>
                                                    <TextField
                                                        rows={0}
                                                        multiline={true}
                                                        label="PassWord"
                                                        placeholder="Enter Password"
                                                        variant="outlined"
                                                        type="password"
                                                        value={data.password}
                                                        className="partnerFormInput"
                                                        onChange={(e: any) => {
                                                            handleChange(["password"], e.target.value)
                                                        }}
                                                    ></TextField>
                                                    <TextField
                                                        rows={0}
                                                        multiline={true}
                                                        label="Contact Number"
                                                        placeholder="Enter Contact Number"
                                                        variant="outlined"
                                                        type="number"
                                                        value={data.contactNo}
                                                        className="partnerFormInput"
                                                        onChange={(e: any) => {
                                                            handleChange(["contactNo"], e.target.value)
                                                        }}
                                                    ></TextField>
                                                    <button className='btn btn-primary otpButton' onClick={() => { handelgetOtp() }}>Get Otp</button>
                                                    <TextField
                                                        rows={0}
                                                        multiline={true}
                                                        label="OTP"
                                                        placeholder="Enter OTP"
                                                        variant="outlined"
                                                        type="number"
                                                        value={data.otp}
                                                        className="partnerFormInput"
                                                        onChange={(e: any) => {
                                                            handleChange(["otp"], e.target.value)
                                                        }}
                                                    ></TextField>
                                                </div>
                                            </div>
                                            : formNo === 1 ?
                                                <div className='formPage1Container'>
                                                    <div className='formPage1Heading'><div className='formTitleName'>  Company Details  </div>  <div> Step {" "} {formNo + 1}/5 </div>
                                                    </div>
                                                    <div className='formPage1'>
                                                        <TextField
                                                            rows={0}
                                                            multiline={true}
                                                            label="Company Name"
                                                            placeholder="Enter Company Name"
                                                            variant="outlined"
                                                            type="text"
                                                            className="partnerFormInput"
                                                            value={data.companyName}
                                                            onChange={(e: any) => {
                                                                handleChange(["companyName"], e.target.value)
                                                            }}
                                                        ></TextField>
                                                        <select
                                                            id="inputState"
                                                            className="form-control selectCompanyType"
                                                            value={data.kind}
                                                            onChange={(e) => {
                                                                handleChange(["kind"], e.target.value)
                                                            }}
                                                        >
                                                            <option label="Company type" value="" />
                                                            {companyTypeList.map((c: any) => (
                                                                <option
                                                                    key={c.id}
                                                                    label={c.name}
                                                                    value={c.name}
                                                                />
                                                            ))}
                                                        </select>
                                                        <TextField
                                                            rows={0}
                                                            multiline={true}
                                                            label="Company Email"
                                                            placeholder="Enter Company Email"
                                                            variant="outlined"
                                                            type="email"
                                                            className="partnerFormInput"
                                                            value={data.companyEmail}
                                                            onChange={(e: any) => {
                                                                handleChange(["companyEmail"], e.target.value)
                                                            }}
                                                        ></TextField>
                                                        <TextField
                                                            rows={0}
                                                            multiline={true}
                                                            label="Company Website"
                                                            placeholder="Enter Company Website"
                                                            variant="outlined"
                                                            type="web"
                                                            value={data.website}
                                                            className="partnerFormInput"
                                                            onChange={(e: any) => {
                                                                handleChange(["website"], e.target.value)
                                                            }}
                                                        ></TextField>
                                                        <Step5
                                                            handleChange={handleChange}
                                                            handlePanCardChange={handlePanCardChange}
                                                            handleLicenceUserChange={handleLicenceUserChange}
                                                            handleUserProfileChange={handleUserProfileChange}
                                                            panNumber={data.panNumber}
                                                            licenceExpire={data.licenceExpire}
                                                            pancard={data.pancard}
                                                            licence={data.licence}
                                                            userProfile={data.userProfile}
                                                        />
                                                    </div>
                                                </div>
                                                : formNo === 2 ?
                                                    <div className='formPage1Container'>
                                                        <div className='formPage1Heading'><div className='formTitleName'> Address  </div>
                                                            <div> Step {" "} {formNo + 1}/5 </div>
                                                        </div>
                                                        <div className='formPage1'>
                                                            <TextField
                                                                rows={0}
                                                                multiline={true}
                                                                label="Branch Name"
                                                                placeholder="Enter Branch Name"
                                                                variant="outlined"
                                                                type="text"
                                                                className="partnerFormInput"
                                                                value={data.branchName}
                                                                onChange={(e: any) => {
                                                                    handleChange(["branchName"], e.target.value)
                                                                }}
                                                            ></TextField>
                                                            <TextField
                                                                rows={0}
                                                                multiline={true}
                                                                label="Short Name"
                                                                placeholder="Enter Short Name"
                                                                variant="outlined"
                                                                type="text"
                                                                className="partnerFormInput"
                                                                value={data.shortName}
                                                                onChange={(e: any) => {
                                                                    handleChange(["shortName"], e.target.value)
                                                                }}
                                                            ></TextField>
                                                            <TextField
                                                                rows={0}
                                                                multiline={true}
                                                                label="Floor No & Building Name"
                                                                placeholder="Enter Floor No & Building Name"
                                                                variant="outlined"
                                                                type="text"
                                                                className="partnerFormInput"
                                                                value={data.line1}
                                                                onChange={(e: any) => {
                                                                    handleChange(["line1"], e.target.value)
                                                                }}
                                                            ></TextField>
                                                            <div className='AutoCompleteDiv'>
                                                                <AutoComplete general={false} onChange={(e: any) => { handleChange(["line2"], e.formatted_address) }} placeHolder="Enter Location" className={"AutoCompleteInput"}></AutoComplete>
                                                            </div>
                                                            <TextField
                                                                rows={0}
                                                                multiline={true}
                                                                label="Pincode"
                                                                placeholder="Enter Pincode"
                                                                variant="outlined"
                                                                type="number"
                                                                className="partnerFormInput"
                                                                value={data.pincode}
                                                                onChange={(e: any) => {
                                                                    handleChange(["pincode"], e.target.value)
                                                                }}
                                                            ></TextField>
                                                            <select
                                                                id="inputState"
                                                                className="div-control citySelect"
                                                                value={data.city}
                                                                onChange={(e: any) => {
                                                                    handleChange(["city"], e.target.value)
                                                                }}
                                                            >
                                                                <option label="City" value="" />
                                                                {cities.map((c: any) => (
                                                                    <option
                                                                        key={c._id}
                                                                        label={c.name}
                                                                        value={c._id}
                                                                    />
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    : formNo === 3 ?
                                                        <div className='formPage1Container'>
                                                            <div className='formPage1Heading'><div className='formTitleName'>  Bank Details  </div>  <div> Step {" "} {formNo + 1}/5 </div>
                                                            </div>
                                                            <div className='formPage1'>
                                                                <TextField
                                                                    rows={0}
                                                                    multiline={true}
                                                                    label="Account Holder"
                                                                    placeholder="Enter Account Holder Name"
                                                                    variant="outlined"
                                                                    type="text"
                                                                    className="partnerFormInput"
                                                                    value={data.AccountHolder}
                                                                    onChange={(e: any) => {
                                                                        handleChange(["AccountHolder"], e.target.value)
                                                                    }}
                                                                ></TextField>
                                                                <TextField
                                                                    rows={0}
                                                                    multiline={true}
                                                                    label="Account Number"
                                                                    placeholder="Enter Account Number"
                                                                    variant="outlined"
                                                                    type="number"
                                                                    className="partnerFormInput"
                                                                    value={data.AccountNo}
                                                                    onChange={(e: any) => {
                                                                        handleChange(["AccountNo"], e.target.value)
                                                                    }}
                                                                ></TextField>
                                                                <TextField
                                                                    rows={0}
                                                                    multiline={true}
                                                                    label="IFSC Code"
                                                                    placeholder="Enter IFSC Code"
                                                                    variant="outlined"
                                                                    type="text"
                                                                    className="partnerFormInput"
                                                                    value={data.IFSCcode}
                                                                    onChange={(e: any) => {
                                                                        handleChange(["IFSCcode"], e.target.value)
                                                                    }}
                                                                ></TextField>
                                                            </div>
                                                        </div>
                                                        : null}
                                        <div className='changeFormbtns'>
                                            {formNo > 0 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => { handleBtns("Previous") }}>PREVIOUS</div> : null}
                                            {formNo <= 2 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => { handleBtns("Next") }}>NEXT</div> : null}
                                            {formNo === 3 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => { handleBtns("Signup"), handleSubmit() }}>SignUp</div>
                                                : props.fleet && formNo === 4 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => { handleBtns("Signup"), handleSubmit() }}>SignUp</div> : null}
                                        </div>
                                    </div>
                                    :
                                    <div className='directSalesAgentContainer'>
                                        {formNo === 0 ?
                                            <div className='formPage1Container'>
                                                <div className='formPage1Heading'>
                                                    <div className='formTitleName'> Contact Person  </div> <div> Step {" "} {formNo + 1}{props.fleet ? "/5" : "/4"} </div>
                                                </div>
                                                <div className='formPage1'>
                                                    <input className='form-control' type={"text"} placeholder='First Name' />
                                                    <br />
                                                    <input className='form-control' type={"text"} placeholder='Last Name' />
                                                    <br />
                                                    <input className='form-control' type={"email"} placeholder='E-mail' />
                                                    <br />
                                                    <input className='form-control' type={"password"} placeholder='Password' />
                                                    <br />
                                                    <input className='form-control' type={"number"} placeholder='Contact No' onChange={(e: any) => { data.contactNo(e) }} />
                                                    <br />
                                                    <button className='btn btn-primary otpButton' onClick={() => { handelgetOtp() }}>Get Otp</button>
                                                    <br />
                                                    <input className='form-control otpInput' type={"number"} placeholder='Enter Otp' />
                                                </div>
                                            </div>
                                            : formNo === 1 ?
                                                <div className='formPage1Container'>
                                                    <div className='formPage1Heading'>
                                                        <div className='formTitleName'> Address  </div> <div> Step {" "} {formNo + 1}{props.fleet ? "/5" : "/4"} </div>
                                                    </div>
                                                    <div className='formPage1'>
                                                        <input className='form-control' type={"text"} placeholder='Address Line 1' />
                                                        <br />
                                                        <input className='form-control' type={"text"} placeholder='Address Line 2' />
                                                        <br />
                                                        <input className='form-control' type={"number"} placeholder='Pincode' />
                                                        <br />
                                                        <select
                                                            id="inputState"
                                                            className="div-control citySelect"
                                                            value={sourceCity}
                                                            onChange={(e) => {
                                                                setSourceCity(e.target.value);
                                                            }}
                                                        >
                                                            <option label="City" value="" />
                                                            {cities.map((c: any) => (
                                                                <option
                                                                    key={c._id}
                                                                    label={c.name}
                                                                    value={c._id}
                                                                />
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                : formNo === 2 ?
                                                    <div className='formPage1Container'>
                                                        <div className='formPage1Heading'>
                                                            <div className='formTitleName'> Attachments  </div> <div> Step {" "} {formNo + 1}{props.fleet ? "/5" : "/4"} </div>
                                                        </div>
                                                        <div>
                                                            <Step5
                                                                handleChange={handleChange}
                                                                handlePanCardChange={handlePanCardChange}
                                                                handleLicenceUserChange={handleLicenceUserChange}
                                                                handleUserProfileChange={handleUserProfileChange}
                                                                panNumber={data.panNumber}
                                                                licenceExpire={data.licenceExpire}
                                                                pancard={data.pancard}
                                                                licence={data.licence}
                                                                userProfile={data.userProfile}
                                                            />
                                                        </div>
                                                    </div>
                                                    : formNo === 3 ?
                                                        <div className='formPage1Container'>
                                                            <div className='formPage1Heading'>
                                                                <div className='formTitleName'> Bank Details  </div> <div> Step {" "} {formNo + 1}{props.fleet ? "/5" : "/4"} </div>
                                                            </div>
                                                            <div className='formPage1'>
                                                                <input className='form-control' type={"text"} placeholder='Account Holder Name' />
                                                                <br />
                                                                <input className='form-control' type={"number"} placeholder='Account Number' />
                                                                <br />
                                                                <input className='form-control' type={"text"} placeholder='IFSC Code' />
                                                            </div>
                                                        </div>
                                                        : formNo === 4 ?
                                                            <div className='formPage1Container'>
                                                                <div className='formPage1Heading'>
                                                                    <div className='formTitleName'> Vehicle Type  </div> <div> Step {" "} {formNo + 1}{props.fleet ? "/5" : "/4"} </div>
                                                                </div>
                                                                <div className='formPage1'>
                                                                    <input className='form-control' type={"text"} placeholder='Vehicle Registration No.' />
                                                                    <br />
                                                                    <select
                                                                        id="inputState"
                                                                        className="form-control fleetRegister mtop2"
                                                                        value={vehicleType}
                                                                        onChange={(e) => {
                                                                            setVehicleType(e.target.value)
                                                                        }}
                                                                    >
                                                                        <option label="Vehicle type" value="" />
                                                                        {vehicleTypeList.map((c: any) => (
                                                                            <option
                                                                                key={c.id}
                                                                                label={c.name}
                                                                                value={c.name}
                                                                            />
                                                                        ))}
                                                                    </select>
                                                                    <br />
                                                                    {vehicleType === "TRAILER" || vehicleType === "CONTAINER" ?
                                                                        <select
                                                                            id="inputState"
                                                                            className="form-control fleetRegister mtop-2"
                                                                            value={vehicleModel}
                                                                            onChange={(e) => {
                                                                                setVehicleModel(e.target.value)
                                                                            }}
                                                                        >
                                                                            <option label="Vehicle Model" value="" />
                                                                            <option
                                                                                label={"Full Covered or Flat Bed"}
                                                                                value={"Full Covered or Flat Bed"}
                                                                            />
                                                                        </select> :
                                                                        <select
                                                                            id="inputState"
                                                                            className="form-control fleetRegister mtop-2"
                                                                            value={vehicleModel}
                                                                            onChange={(e) => {
                                                                                setVehicleModel(e.target.value)
                                                                            }}
                                                                        >
                                                                            <option label="Vehicle Model" value="" />
                                                                            {vehicleModelTypeList.map((c: any) => (
                                                                                <option
                                                                                    key={c.id}
                                                                                    label={c.name}
                                                                                    value={c.name}
                                                                                />
                                                                            ))}
                                                                        </select>
                                                                    }
                                                                </div>
                                                            </div> : null}
                                        <div className='changeFormbtns'>
                                            {formNo > 0 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => setFormNo(formNo - 1)}>PREVIOUS</div > : null}
                                            {formNo <= 2 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => setFormNo(formNo + 1)}>NEXT</div > :
                                                props.fleet && formNo <= 3 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => setFormNo(formNo + 1)}>NEXT</div > : null}
                                            {!props.fleet && formNo === 3 ? <div className="btn btn-primary-one text-white puBtn" >SignUp</div >
                                                : props.fleet && formNo === 4 ? <div className="btn btn-primary-one text-white puBtn" >SignUp</div > : null}
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </>
                :
                <>
                    <div className='partNersFormDiv'>
                        <div className='parnersImageConainer'>
                            <img src='data:image/jpeg;base64,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' />
                        </div>
                        {props.formName === "TransportCompnay" ?
                            <div className='directSalesAgentContainer'>
                                <div className='headingForPartnersForm'>
                                    <h5>Become A Partner</h5>
                                </div>
                                {formNo === 0 ?
                                    <div className='formPage1Container'>
                                        <div className='formPage1Heading'>
                                            <div className='formTitleName'> Contact Person  </div>  <div> Step {" "} {formNo + 1}/4 </div>
                                        </div>
                                        <div className='formPage1'>
                                            <TextField
                                                rows={0}
                                                multiline={true}
                                                label="First Name"
                                                value={data.fName}
                                                placeholder="Enter First Name"
                                                variant="outlined"
                                                type="text"
                                                className="partnerFormInput"
                                                onChange={(e: any) => {
                                                    handleChange(["fName"], e.target.value)
                                                }}
                                            ></TextField>
                                            <TextField
                                                rows={0}
                                                multiline={true}
                                                label="Last Name"
                                                placeholder="Enter Last Name"
                                                variant="outlined"
                                                type="text"
                                                value={data.lName}
                                                className="partnerFormInput"
                                                onChange={(e: any) => {
                                                    handleChange(["lName"], e.target.value)
                                                }}
                                            ></TextField>
                                            <TextField
                                                rows={0}
                                                multiline={true}
                                                label="Email Address"
                                                placeholder="Enter Email Address"
                                                variant="outlined"
                                                value={data.email}
                                                type="email"
                                                className="partnerFormInput"
                                                onChange={(e: any) => {
                                                    handleChange(["email"], e.target.value)
                                                }}
                                            ></TextField>
                                            <TextField
                                                rows={0}
                                                multiline={true}
                                                label="PassWord"
                                                placeholder="Enter Password"
                                                variant="outlined"
                                                type="password"
                                                value={data.password}
                                                className="partnerFormInput"
                                                onChange={(e: any) => {
                                                    handleChange(["password"], e.target.value)
                                                }}
                                            ></TextField>
                                            <TextField
                                                rows={0}
                                                multiline={true}
                                                label="Contact Number"
                                                placeholder="Enter Contact Number"
                                                variant="outlined"
                                                type="number"
                                                value={data.contactNo}
                                                className="partnerFormInput"
                                                onChange={(e: any) => {
                                                    handleChange(["contactNo"], e.target.value)
                                                }}
                                            ></TextField>
                                            <button className='btn btn-primary otpButton' onClick={() => { handelgetOtp() }}>Get Otp</button>
                                            <TextField
                                                rows={0}
                                                multiline={true}
                                                label="OTP"
                                                placeholder="Enter OTP"
                                                variant="outlined"
                                                type="number"
                                                value={data.otp}
                                                className="partnerFormInput"
                                                onChange={(e: any) => {
                                                    handleChange(["otp"], e.target.value)
                                                }}
                                            ></TextField>
                                        </div>
                                    </div>
                                    : formNo === 1 ?
                                        <div className='formPage1Container'>
                                            <div className='formPage1Heading'><div className='formTitleName'>  Company Details  </div>  <div> Step {" "} {formNo + 1}/5 </div>
                                            </div>
                                            <div className='formPage1'>
                                                <TextField
                                                    rows={0}
                                                    multiline={true}
                                                    label="Company Name"
                                                    placeholder="Enter Company Name"
                                                    variant="outlined"
                                                    type="text"
                                                    className="partnerFormInput"
                                                    value={data.companyName}
                                                    onChange={(e: any) => {
                                                        handleChange(["companyName"], e.target.value)
                                                    }}
                                                ></TextField>
                                                <select
                                                    id="inputState"
                                                    className="form-control selectCompanyType"
                                                    value={data.kind}
                                                    onChange={(e) => {
                                                        handleChange(["kind"], e.target.value)
                                                    }}
                                                >
                                                    <option label="Company type" value="" />
                                                    {companyTypeList.map((c: any) => (
                                                        <option
                                                            key={c.id}
                                                            label={c.name}
                                                            value={c.name}
                                                        />
                                                    ))}
                                                </select>
                                                <TextField
                                                    rows={0}
                                                    multiline={true}
                                                    label="Company Email"
                                                    placeholder="Enter Company Email"
                                                    variant="outlined"
                                                    type="email"
                                                    className="partnerFormInput"
                                                    value={data.companyEmail}
                                                    onChange={(e: any) => {
                                                        handleChange(["companyEmail"], e.target.value)
                                                    }}
                                                ></TextField>
                                                <TextField
                                                    rows={0}
                                                    multiline={true}
                                                    label="Company Website"
                                                    placeholder="Enter Company Website"
                                                    variant="outlined"
                                                    type="web"
                                                    value={data.website}
                                                    className="partnerFormInput"
                                                    onChange={(e: any) => {
                                                        handleChange(["website"], e.target.value)
                                                    }}
                                                ></TextField>
                                                <Step5
                                                    handleChange={handleChange}
                                                    handlePanCardChange={handlePanCardChange}
                                                    handleLicenceUserChange={handleLicenceUserChange}
                                                    handleUserProfileChange={handleUserProfileChange}
                                                    panNumber={data.panNumber}
                                                    licenceExpire={data.licenceExpire}
                                                    pancard={data.pancard}
                                                    licence={data.licence}
                                                    userProfile={data.userProfile}
                                                />
                                            </div>
                                        </div>
                                        : formNo === 2 ?
                                            <div className='formPage1Container'>
                                                <div className='formPage1Heading'><div className='formTitleName'> Address  </div>
                                                    <div> Step {" "} {formNo + 1}/5 </div>
                                                </div>
                                                <div className='formPage1'>
                                                    <TextField
                                                        rows={0}
                                                        multiline={true}
                                                        label="Branch Name"
                                                        placeholder="Enter Branch Name"
                                                        variant="outlined"
                                                        type="text"
                                                        className="partnerFormInput"
                                                        value={data.branchName}
                                                        onChange={(e: any) => {
                                                            handleChange(["branchName"], e.target.value)
                                                        }}
                                                    ></TextField>
                                                    <TextField
                                                        rows={0}
                                                        multiline={true}
                                                        label="Short Name"
                                                        placeholder="Enter Short Name"
                                                        variant="outlined"
                                                        type="text"
                                                        className="partnerFormInput"
                                                        value={data.shortName}
                                                        onChange={(e: any) => {
                                                            handleChange(["shortName"], e.target.value)
                                                        }}
                                                    ></TextField>
                                                    <TextField
                                                        rows={0}
                                                        multiline={true}
                                                        label="Floor No & Building Name"
                                                        placeholder="Enter Floor No & Building Name"
                                                        variant="outlined"
                                                        type="text"
                                                        className="partnerFormInput"
                                                        value={data.line1}
                                                        onChange={(e: any) => {
                                                            handleChange(["line1"], e.target.value)
                                                        }}
                                                    ></TextField>
                                                    <div className='AutoCompleteDiv'>
                                                        <AutoComplete general={false} onChange={(e: any) => { handleChange(["line2"], e.formatted_address) }} placeHolder="Enter Location" className={"AutoCompleteInput"}></AutoComplete>
                                                    </div>
                                                    <TextField
                                                        rows={0}
                                                        multiline={true}
                                                        label="Pincode"
                                                        placeholder="Enter Pincode"
                                                        variant="outlined"
                                                        type="number"
                                                        className="partnerFormInput"
                                                        value={data.pincode}
                                                        onChange={(e: any) => {
                                                            handleChange(["pincode"], e.target.value)
                                                        }}
                                                    ></TextField>
                                                    <select
                                                        id="inputState"
                                                        className="div-control citySelect"
                                                        value={data.city}
                                                        onChange={(e: any) => {
                                                            handleChange(["city"], e.target.value)
                                                        }}
                                                    >
                                                        <option label="City" value="" />
                                                        {cities.map((c: any) => (
                                                            <option
                                                                key={c._id}
                                                                label={c.name}
                                                                value={c._id}
                                                            />
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            : formNo === 3 ?
                                                <div className='formPage1Container'>
                                                    <div className='formPage1Heading'><div className='formTitleName'>  Bank Details  </div>  <div> Step {" "} {formNo + 1}/5 </div>
                                                    </div>
                                                    <div className='formPage1'>
                                                        <TextField
                                                            rows={0}
                                                            multiline={true}
                                                            label="Account Holder"
                                                            placeholder="Enter Account Holder Name"
                                                            variant="outlined"
                                                            type="text"
                                                            className="partnerFormInput"
                                                            value={data.AccountHolder}
                                                            onChange={(e: any) => {
                                                                handleChange(["AccountHolder"], e.target.value)
                                                            }}
                                                        ></TextField>
                                                        <TextField
                                                            rows={0}
                                                            multiline={true}
                                                            label="Account Number"
                                                            placeholder="Enter Account Number"
                                                            variant="outlined"
                                                            type="number"
                                                            className="partnerFormInput"
                                                            value={data.AccountNo}
                                                            onChange={(e: any) => {
                                                                handleChange(["AccountNo"], e.target.value)
                                                            }}
                                                        ></TextField>
                                                        <TextField
                                                            rows={0}
                                                            multiline={true}
                                                            label="IFSC Code"
                                                            placeholder="Enter IFSC Code"
                                                            variant="outlined"
                                                            type="text"
                                                            className="partnerFormInput"
                                                            value={data.IFSCcode}
                                                            onChange={(e: any) => {
                                                                handleChange(["IFSCcode"], e.target.value)
                                                            }}
                                                        ></TextField>
                                                    </div>
                                                </div>
                                                : null}
                                <div className='changeFormbtns'>
                                    {formNo > 0 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => { handleBtns("Previous") }}>PREVIOUS</div> : null}
                                    {formNo <= 2 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => { handleBtns("Next") }}>NEXT</div> : null}
                                    {formNo === 3 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => { handleBtns("Signup"), handleSubmit() }}>SignUp</div>
                                        : props.fleet && formNo === 4 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => { handleBtns("Signup"), handleSubmit() }}>SignUp</div> : null}
                                </div>
                            </div>
                            :
                            props.formName === "individualWithFleet" ?
                                <div className='directSalesAgentContainer'>
                                    <div className='headingForPartnersForm'>
                                        <h5>Become A Partner</h5>
                                    </div>
                                    {formNo === 0 ?
                                        <div className='formPage1Container'>
                                            <div className='formPage1Heading'>
                                                <div className='formTitleName'> Contact Person  </div>  <div> Step {" "} {formNo + 1}/4 </div>
                                            </div>
                                            <ContactDetailsForm
                                                className={"individualWFContactForm"}
                                                commonUsedForm={true}
                                                submitBtn={false}
                                                emailClass={"emailDesign"}
                                                formTitle={"individualWFContactForm"}
                                            />
                                            {/* <div className='formPage1'>
                                <TextField
                                    rows={0}
                                    multiline={true}
                                    label="First Name"
                                    value={data.fName}
                                    placeholder="Enter First Name"
                                    variant="outlined"
                                    type="text"
                                    className="partnerFormInput"
                                    onChange={(e:any)=>{
                                        handleChange(["fName"], e.target.value)
                                    }}
                                ></TextField>
                                <TextField
                                    rows={0}
                                    multiline={true}
                                    label="Last Name"
                                    placeholder="Enter Last Name"
                                    variant="outlined"
                                    type="text"
                                    value={data.lName}
                                    className="partnerFormInput"
                                    onChange={(e:any)=>{
                                        handleChange(["lName"], e.target.value)
                                    }}
                                ></TextField>
                                <TextField
                                    rows={0}
                                    multiline={true}
                                    label="Email Address"
                                    placeholder="Enter Email Address"
                                    variant="outlined"
                                    value={data.email}
                                    type="email"
                                    className="partnerFormInput"
                                    onChange={(e:any)=>{
                                        handleChange(["email"], e.target.value)
                                    }}
                                ></TextField>
                                <TextField
                                    rows={0}
                                    multiline={true}
                                    label="PassWord"
                                    placeholder="Enter Password"
                                    variant="outlined"
                                    type="password"
                                    value={data.password}
                                    className="partnerFormInput"
                                    onChange={(e:any)=>{
                                        handleChange(["password"], e.target.value)
                                    }}
                                ></TextField>
                                <TextField
                                    rows={0}
                                    multiline={true}
                                    label="Contact Number"
                                    placeholder="Enter Contact Number"
                                    variant="outlined"
                                    type="number"
                                    value={data.contactNo}
                                    className="partnerFormInput"
                                    onChange={(e:any)=>{
                                        handleChange(["contactNo"], e.target.value)
                                    }}
                                ></TextField>
                                <button className='btn btn-primary otpButton' onClick={()=>{handelgetOtp()}}>Get Otp</button>
                                <TextField
                                    rows={0}
                                    multiline={true}
                                    label="OTP"
                                    placeholder="Enter OTP"
                                    variant="outlined"
                                    type="number"
                                    value={data.otp}
                                    className="partnerFormInput"
                                    onChange={(e:any)=>{
                                        handleChange(["otp"], e.target.value)
                                    }}
                                ></TextField>
                            </div> */}
                                        </div>
                                        : formNo === 1 ?
                                            <div className='formPage1Container'>
                                                <div className='formPage1Heading'><div className='formTitleName'>  Attachments  </div>  <div> Step {" "} {formNo + 1}/5 </div>
                                                </div>
                                                {/* <div className='formPage1'>
                            <TextField
                                rows={0}
                                multiline={true}
                                label="Company Name"
                                placeholder="Enter Company Name"
                                variant="outlined"
                                type="text"
                                className="partnerFormInput"
                                value={data.companyName}
                                onChange={(e:any)=>{
                                    handleChange(["companyName"], e.target.value)
                                }}
                            ></TextField>
                            <select
                                id="inputState"
                                className="form-control selectCompanyType"
                                value={data.kind}
                                onChange={(e) => {
                                    handleChange(["kind"],e.target.value)
                                }}
                                >
                                <option label="Company type" value="" />
                                {companyTypeList.map((c: any) => (
                                    <option
                                    key={c.id}
                                    label={c.name}
                                    value={c.name}
                                    />
                                    ))}
                            </select> 
                            <TextField
                                rows={0}
                                multiline={true}
                                label="Company Email"
                                placeholder="Enter Company Email"
                                variant="outlined"
                                type="email"
                                className="partnerFormInput"
                                value={data.companyEmail}
                                onChange={(e:any)=>{
                                    handleChange(["companyEmail"], e.target.value)
                                }}
                            ></TextField>
                            <TextField
                                rows={0}
                                multiline={true}
                                label="Company Website"
                                placeholder="Enter Company Website"
                                variant="outlined"
                                type="web"
                                value={data.website}
                                className="partnerFormInput"
                                onChange={(e:any)=>{
                                    handleChange(["website"], e.target.value)
                                }}
                            ></TextField>
                            <Step5
                                handleChange={handleChange}
                                handlePanCardChange={handlePanCardChange}
                                handleLicenceUserChange={handleLicenceUserChange}
                                handleUserProfileChange={handleUserProfileChange}
                                panNumber={data.panNumber}
                                licenceExpire={data.licenceExpire}
                                pancard={data.pancard}
                                licence={data.licence}
                                userProfile={data.userProfile}
                            />
                        </div> */}
                                                <Step5
                                                    handleChange={handleChange}
                                                    handlePanCardChange={handlePanCardChange}
                                                    handleLicenceUserChange={handleLicenceUserChange}
                                                    handleUserProfileChange={handleUserProfileChange}
                                                    panNumber={data.panNumber}
                                                    licenceExpire={data.licenceExpire}
                                                    pancard={data.pancard}
                                                    licence={data.licence}
                                                    userProfile={data.userProfile}
                                                />
                                            </div>
                                            : formNo === 2 ?
                                                <div className='formPage1Container'>
                                                    <div className='formPage1Heading'><div className='formTitleName'> Address  </div>
                                                        <div> Step {" "} {formNo + 1}/5 </div>
                                                    </div>
                                                    <div className='formPage1'>
                                                        <TextField
                                                            rows={0}
                                                            multiline={true}
                                                            label="Branch Name"
                                                            placeholder="Enter Branch Name"
                                                            variant="outlined"
                                                            type="text"
                                                            className="partnerFormInput"
                                                            value={data.branchName}
                                                            onChange={(e: any) => {
                                                                handleChange(["branchName"], e.target.value)
                                                            }}
                                                        ></TextField>
                                                        <TextField
                                                            rows={0}
                                                            multiline={true}
                                                            label="Short Name"
                                                            placeholder="Enter Short Name"
                                                            variant="outlined"
                                                            type="text"
                                                            className="partnerFormInput"
                                                            value={data.shortName}
                                                            onChange={(e: any) => {
                                                                handleChange(["shortName"], e.target.value)
                                                            }}
                                                        ></TextField>
                                                        <TextField
                                                            rows={0}
                                                            multiline={true}
                                                            label="Floor No & Building Name"
                                                            placeholder="Enter Floor No & Building Name"
                                                            variant="outlined"
                                                            type="text"
                                                            className="partnerFormInput"
                                                            value={data.line1}
                                                            onChange={(e: any) => {
                                                                handleChange(["line1"], e.target.value)
                                                            }}
                                                        ></TextField>
                                                        <div className='AutoCompleteDiv'>
                                                            <AutoComplete general={false} onChange={(e: any) => { handleChange(["line2"], e.formatted_address) }} placeHolder="Enter Location" className={"AutoCompleteInput"}></AutoComplete>
                                                        </div>
                                                        <TextField
                                                            rows={0}
                                                            multiline={true}
                                                            label="Pincode"
                                                            placeholder="Enter Pincode"
                                                            variant="outlined"
                                                            type="number"
                                                            className="partnerFormInput"
                                                            value={data.pincode}
                                                            onChange={(e: any) => {
                                                                handleChange(["pincode"], e.target.value)
                                                            }}
                                                        ></TextField>
                                                        <select
                                                            id="inputState"
                                                            className="div-control citySelect"
                                                            value={data.city}
                                                            onChange={(e: any) => {
                                                                handleChange(["city"], e.target.value)
                                                            }}
                                                        >
                                                            <option label="City" value="" />
                                                            {cities.map((c: any) => (
                                                                <option
                                                                    key={c._id}
                                                                    label={c.name}
                                                                    value={c._id}
                                                                />
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                : formNo === 3 ?
                                                    <div className='formPage1Container'>
                                                        <div className='formPage1Heading'><div className='formTitleName'>  Bank Details  </div>  <div> Step {" "} {formNo + 1}/5 </div>
                                                        </div>
                                                        <div className='formPage1'>
                                                            <TextField
                                                                rows={0}
                                                                multiline={true}
                                                                label="Account Holder"
                                                                placeholder="Enter Account Holder Name"
                                                                variant="outlined"
                                                                type="text"
                                                                className="partnerFormInput"
                                                                value={data.AccountHolder}
                                                                onChange={(e: any) => {
                                                                    handleChange(["AccountHolder"], e.target.value)
                                                                }}
                                                            ></TextField>
                                                            <TextField
                                                                rows={0}
                                                                multiline={true}
                                                                label="Account Number"
                                                                placeholder="Enter Account Number"
                                                                variant="outlined"
                                                                type="number"
                                                                className="partnerFormInput"
                                                                value={data.AccountNo}
                                                                onChange={(e: any) => {
                                                                    handleChange(["AccountNo"], e.target.value)
                                                                }}
                                                            ></TextField>
                                                            <TextField
                                                                rows={0}
                                                                multiline={true}
                                                                label="IFSC Code"
                                                                placeholder="Enter IFSC Code"
                                                                variant="outlined"
                                                                type="text"
                                                                className="partnerFormInput"
                                                                value={data.IFSCcode}
                                                                onChange={(e: any) => {
                                                                    handleChange(["IFSCcode"], e.target.value)
                                                                }}
                                                            ></TextField>
                                                        </div>
                                                    </div>
                                                    : null}
                                    <div className='changeFormbtns'>
                                        {formNo > 0 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => { handleBtns("Previous") }}>PREVIOUS</div> : null}
                                        {formNo <= 2 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => { handleBtns("Next") }}>NEXT</div> : null}
                                        {formNo === 3 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => { handleBtns("Signup"), handleSubmit() }}>SignUp</div>
                                            : props.fleet && formNo === 4 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => { handleBtns("Signup"), handleSubmit() }}>SignUp</div> : null}
                                    </div>
                                </div>
                                :
                                <div className='directSalesAgentContainer'>
                                    <div className='headingForPartnersForm'>
                                        <h5>Become A Partner</h5>
                                    </div>
                                    {formNo === 0 ?
                                        <div className='formPage1Container'>
                                            <div className='formPage1Heading'>
                                                <div className='formTitleName'> Contact Person  </div>  <div> Step {" "} {formNo + 1}{props.fleet ? "/5" : "/4"} </div>
                                            </div>
                                            <div className='formPage1'>
                                                <input className='form-control' type={"text"} placeholder='First Name' />
                                                <br />
                                                <input className='form-control' type={"text"} placeholder='Last Name' />
                                                <br />
                                                <input className='form-control' type={"email"} placeholder='E-mail' />
                                                <br />
                                                <input className='form-control' type={"password"} placeholder='Password' />
                                                <br />
                                                <input className='form-control' type={"number"} placeholder='Contact No' onChange={(e: any) => { data.contactNo(e) }} />
                                                <br />
                                                <button className='btn btn-primary otpButton' onClick={() => { handelgetOtp() }}>Get Otp</button>
                                                <br />
                                                <input className='form-control otpInput' type={"number"} placeholder='Enter Otp' />
                                            </div>
                                        </div>
                                        : formNo === 1 ?
                                            <div className='formPage1Container'>
                                                <div className='formPage1Heading'>
                                                    <div className='formTitleName'> Address  </div>  <div> Step {" "} {formNo + 1}{props.fleet ? "/5" : "/4"} </div>
                                                </div>
                                                <div className='formPage1'>
                                                    <input className='form-control' type={"text"} placeholder='Address Line 1' />
                                                    <br />
                                                    <input className='form-control' type={"text"} placeholder='Address Line 2' />
                                                    <br />
                                                    <input className='form-control' type={"number"} placeholder='Pincode' />
                                                    <br />
                                                    <select
                                                        id="inputState"
                                                        className="div-control citySelect"
                                                        value={sourceCity}
                                                        onChange={(e) => {
                                                            setSourceCity(e.target.value);
                                                        }}
                                                    >
                                                        <option label="City" value="" />
                                                        {cities.map((c: any) => (
                                                            <option
                                                                key={c._id}
                                                                label={c.name}
                                                                value={c._id}
                                                            />
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            : formNo === 2 ?
                                                <div className='formPage1Container'>
                                                    <div className='formPage1Heading'>
                                                        <div className='formTitleName'> Attachments  </div>  <div> Step {" "} {formNo + 1}{props.fleet ? "/5" : "/4"} </div>
                                                    </div>
                                                    <div>
                                                        <Step5
                                                            handleChange={handleChange}
                                                            handlePanCardChange={handlePanCardChange}
                                                            handleLicenceUserChange={handleLicenceUserChange}
                                                            handleUserProfileChange={handleUserProfileChange}
                                                            panNumber={data.panNumber}
                                                            licenceExpire={data.licenceExpire}
                                                            pancard={data.pancard}
                                                            licence={data.licence}
                                                            userProfile={data.userProfile}
                                                        />
                                                    </div>
                                                </div>
                                                : formNo === 3 ?
                                                    <div className='formPage1Container'>
                                                        <div className='formPage1Heading'>
                                                            <div className='formTitleName'> Bank Details  </div>  <div> Step {" "} {formNo + 1}{props.fleet ? "/5" : "/4"} </div>
                                                        </div>
                                                        <div className='formPage1'>
                                                            <input className='form-control' type={"text"} placeholder='Account Holder Name' />
                                                            <br />
                                                            <input className='form-control' type={"number"} placeholder='Account Number' />
                                                            <br />
                                                            <input className='form-control' type={"text"} placeholder='IFSC Code' />
                                                        </div>
                                                    </div>
                                                    : formNo === 4 ?
                                                        <div className='formPage1Container'>
                                                            <div className='formPage1Heading'>
                                                                <div className='formTitleName'> Vehicle Type  </div>  <div> Step {" "} {formNo + 1}{props.fleet ? "/5" : "/4"} </div>
                                                            </div>
                                                            <div className='formPage1'>
                                                                <input className='form-control' type={"text"} placeholder='Vehicle Registration No.' />
                                                                <br />
                                                                <select
                                                                    id="inputState"
                                                                    className="form-control fleetRegister mtop2"
                                                                    value={vehicleType}
                                                                    onChange={(e) => {
                                                                        setVehicleType(e.target.value)
                                                                    }}
                                                                >
                                                                    <option label="Vehicle type" value="" />
                                                                    {vehicleTypeList.map((c: any) => (
                                                                        <option
                                                                            key={c.id}
                                                                            label={c.name}
                                                                            value={c.name}
                                                                        />
                                                                    ))}
                                                                </select>
                                                                <br />
                                                                {vehicleType === "TRAILER" || vehicleType === "CONTAINER" ?
                                                                    <select
                                                                        id="inputState"
                                                                        className="form-control fleetRegister mtop-2"
                                                                        value={vehicleModel}
                                                                        onChange={(e) => {
                                                                            setVehicleModel(e.target.value)
                                                                        }}
                                                                    >
                                                                        <option label="Vehicle Model" value="" />
                                                                        <option
                                                                            label={"Full Covered or Flat Bed"}
                                                                            value={"Full Covered or Flat Bed"}
                                                                        />
                                                                    </select> :
                                                                    <select
                                                                        id="inputState"
                                                                        className="form-control fleetRegister mtop-2"
                                                                        value={vehicleModel}
                                                                        onChange={(e) => {
                                                                            setVehicleModel(e.target.value)
                                                                        }}
                                                                    >
                                                                        <option label="Vehicle Model" value="" />
                                                                        {vehicleModelTypeList.map((c: any) => (
                                                                            <option
                                                                                key={c.id}
                                                                                label={c.name}
                                                                                value={c.name}
                                                                            />
                                                                        ))}
                                                                    </select>
                                                                }
                                                            </div>
                                                        </div> : null}
                                    <div className='changeFormbtns'>
                                        {formNo > 0 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => setFormNo(formNo - 1)}>PREVIOUS</div> : null}
                                        {formNo <= 2 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => setFormNo(formNo + 1)}>NEXT</div> :
                                            props.fleet && formNo <= 3 ? <div className="btn btn-primary-one text-white puBtn" onClick={() => setFormNo(formNo + 1)}>NEXT</div> : null}
                                        {!props.fleet && formNo === 3 ? <div className="btn btn-primary-one text-white puBtn">SignUp</div>
                                            : props.fleet && formNo === 4 ? <div className="btn btn-primary-one text-white puBtn">SignUp</div> : null}
                                    </div>
                                </div>
                        }
                    </div>
                </>
            }
        </>
    )
}

export default PartnersForms